export default "__VITE_ASSET__$YQKMS0w__"